import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-alert-text',
    templateUrl: './alert-text.component.html'
})
export class AlertTextComponent implements OnChanges {
    @Input() type: 'success' | 'error' | 'warning' | 'info';
    @Input() textXS = true;
    @Input() textBold = true;
    @Input() iconSize: 'small' | 'big' = 'small';
    color: string = '#856404';
    constructor() {}

    ngOnChanges() {
        this.setColor();
    }

    setColor() {
        switch (this.type) {
            case 'success':
                this.color = '#155724';
                break;
            case 'error':
                this.color = '#721c24';
                break;
            case 'warning':
                this.color = '#856404';
                break;
            case 'info':
                this.color = '#004085';
                break;
        }
    }
}
